export default __webpack_public_path__ + "static/media/iron.65aee982.svg";